const endpoint = "http://localhost:4000";
const prodEndpoint = "https://pictophone-server.herokuapp.com/";

module.exports = { endpoint, prodEndpoint };
